import { Box } from '@mui/material'

import useStyles from './style'

type Props = {
  label: string
  colorTag: string
  colorText: string
}

const Tag = ({ label, colorTag, colorText }: Props) => {
  const classes = useStyles({ colorTag, colorText })

  return (
    <Box id={`tag-${label}`} className={classes.tag}>
      {label}
    </Box>
  )
}

export default Tag
